<template>
  <div :title="$t('sectionModalPayment.clickToSendPaymentLink')">
    <button class="btn-square btn-info btn-rounded" @click="AbrirModal()">
      <i class="fas fa-dollar-sign"></i>
      <!-- <i class="fa fa-paperclip attachment" aria-hidden="true" /> -->
    </button>
    <b-modal
      v-model="abrir"
      :title="$t('sectionModalPayment.sendPaymentLink')"
      size="lg"
      hide-footer
    >
      <div v-if="!possuiIntegracao" class="row">
        <div class="col">
          <div class="alert alert-warning" role="alert">
            <h4>
              {{ $t("sectionModalPayment.paymentIntegrationNotConfigured") }}
              <a href="https://www.paylink.com.br/quanto-custa" target="_blank">
                {{ $t("sectionModalPayment.clickHereToConsultThePlan") }}
              </a>
              . {{ $t("sectionModalPayment.associatePharmacy") }}
            </h4>
            <h4>
              {{ $t("sectionModalPayment.requestConfigureIntegration") }}
              <a href="/#/configuracao-pagamento" target="_blank">
                {{ $t("sectionModalPayment.clickToConfigureIntegration") }}
              </a>
            </h4>
          </div>
        </div>
      </div>
      <form v-else @submit="ValidarForm">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <small>{{ $t("textObrigatorios") }}</small>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for>* {{ $t("sectionOrcamento.orcamentoNome") }}</label>
              <input
                v-model="viewModel.nome"
                class="form-control"
                type="text"
                :placeholder="$t('sectionModalPayment.enterName')"
                maxlength="100"
                required
              />
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label for
                >* {{ $t("sectionParametro.parametroDocumento") }}</label
              >
              <input
                v-model="viewModel.documento"
                class="form-control"
                type="text"
                :placeholder="$t('sectionModalPayment.enterDocumentNumber')"
                maxlength="15"
                required
              />
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label for>* {{ $t("sectionPessoa.pessoaEmail") }}</label>
              <input
                v-model="viewModel.email"
                class="form-control"
                type="email"
                :placeholder="$t('sectionModalPayment.enterEmail')"
                maxlength="100"
                required
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for>* {{ $t("sectionOrcamento.orcamentoValor") }}</label>
              <input
                v-model="viewModel.valor"
                class="form-control"
                type="number"
                step="0.01"
                :placeholder="$t('sectionModalPayment.enterValue')"
                required
              />
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label for>* {{ $t("sectionModalPayment.portion") }}</label>
              <select v-model="viewModel.parcela" class="form-control" required>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="6">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
              </select>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label for>{{ $t("sectionOrcamento.orcamentoTitle") }}</label>
              <input
                v-model="viewModel.orcamento"
                class="form-control"
                type="number"
                :placeholder="$t('sectionModalPayment.enterBudgetNumber')"
              />
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col">
            <button class="btn btn-success" type="submit">
              {{ $t("btEnviar") }}
            </button>
          </div>
        </div>
        <div v-if="loading" class="loading-container">
          <RotateSquare
            class="loading-position animated fadeIn"
            size="60px"
          ></RotateSquare>
        </div>
        <div v-else>
          <div class="row">
            <div class="col">
              <label> {{ $t("sectionModalPayment.budgetOnly") }} </label>
            </div>
          </div>
          <b-table
            :hover="true"
            responsive
            :items="itens"
            :fields="fields"
            striped
            :per-page="itensPorPagina"
            show-empty
            :empty-text="$t('sectionModalPayment.notBudgetFound')"
          >
            <template v-slot:empty="scope">
              <h4>{{ scope.emptyText }}</h4>
            </template>
            <template v-slot:cell(valor)="data">
              <div class="center">
                <label for="">R$ {{ data.item.valor }}</label>
              </div>
            </template>
            <template v-slot:cell(acao)="data">
              <div class="d-flex flex-content-row flex-center">
                <b-button
                  :variant="
                    data.item.integracaoId == viewModel.orcamento
                      ? 'success'
                      : 'secondary'
                  "
                  :title="$t('sectionModalPayment.clickToSelectBudget')"
                  @click="OnSelecionado(data.item)"
                >
                  <i class="fa fa-check" style="color: black;"></i>
                </b-button>
              </div>
            </template>
          </b-table>
          <b-pagination
            v-model="pagina"
            :total-rows="total"
            :per-page="itensPorPagina"
            align="right"
            size="md"
            class="mt-2"
          ></b-pagination>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import RotateSquare from "../../components/RotateSquare";
import EnumStatusOrcamento from "../../enums/StatusOrcamento";

export default {
  name: "ModalPayment",
  components: {
    RotateSquare
  },
  props: {
    contatoId: {
      type: String,
      default: ""
    },
    evento: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      viewModel: {
        nome: "",
        valor: "",
        documento: "",
        orcamento: "",
        parcela: 1,
        email: "",
        enviarEmail: false,
        contaId: this.$store.getters.getAutenticacao.contaSelecionadaId,
        contatoId: ""
      },
      possuiIntegracao: false,
      loading: false,
      abrir: false,
      itens: [],
      pagina: 1,
      total: 0,
      itensPorPagina: 5
    };
  },
  computed: {
    fields() {
      return [
        {
          key: "integracaoId",
          label: this.$t("textNumero"),
          sortable: true,
          tdClass: "CustomTd"
        },
        {
          key: "valor",
          label: this.$t("sectionOrcamento.orcamentoValor"),
          sortable: true
        },
        {
          key: "acao",
          label: this.$t("sectionOrcamento.orcamentoAcao"),
          sortable: false,
          thClass: "center, wd-120-px"
        }
      ];
    }
  },
  watch: {
    pagina: function (val) {
      this.ObterGrid(val);
    }
  },
  methods: {
    OnSelecionado(item) {
      this.viewModel.orcamento = item.integracaoId;
      this.viewModel.valor = item.valor;
    },
    ValidarForm(evt) {
      evt.preventDefault();
      this.Novo();
    },
    FormatarMensagem(link) {
      let msg =
        this.viewModel.nome +
        ` ${this.$t("sectionModalPayment.followThePaymentLink")}`;
      msg +=
        " R$ " +
        this.viewModel.valor.toLocaleString() +
        ` ${this.$t("sectionModalPayment.in")} ` +
        this.viewModel.parcela +
        "x -";

      if (this.viewModel.orcamento)
        msg +=
          ` ${this.$t("sectionModalPayment.budgetNumber")} ` +
          this.viewModel.orcamento +
          ",";

      msg += " " + link;
      this.$emit(this.evento, msg);
    },
    Novo() {
      this.loading = true;
      this.$http({
        url: "pagamento/gerar",
        data: this.viewModel,
        method: "POST"
      })
        .then((response) => {
          this.loading = false;
          this.FormatarMensagem(response.data);

          this.abrir = false;
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    },
    AbrirModal() {
      this.abrir = true;
      this.PossuiIntegracao();
      this.viewModel.contaId = this.$store.getters.getAutenticacao.contaSelecionadaId;
      this.viewModel.contatoId = this.contatoId;
      this.viewModel.nome = "";
      this.viewModel.valor = "";
      this.viewModel.documento = "";
      this.viewModel.orcamento = "";
      this.viewModel.parcela = 1;
      this.viewModel.email = "";
      this.viewModel.enviarEmail = false;
      this.itens = [];
      this.total = 0;
      this.pagina = 1;
      this.itensPorPagina = 5;
    },
    PossuiIntegracao() {
      this.$http({
        url: "/pagamento/possui-integracao/" + this.viewModel.contaId,
        method: "GET"
      })
        .then((response) => {
          this.possuiIntegracao = response.data;
          if (this.possuiIntegracao) {
            this.ObterPessoa();
            this.ObterGrid(this.pagina);
          }
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    },
    ObterPessoa() {
      this.$http({
        url:
          "/pessoa/obter-por-contato/" +
          this.contatoId +
          "/" +
          this.viewModel.contaId,
        method: "GET"
      })
        .then((response) => {
          this.viewModel.nome = response.data.nome;
          this.viewModel.documento = response.data.documento;
          this.viewModel.email = response.data.email;
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    },
    ObterGrid(pagina) {
      this.loading = true;
      let filtro = {
        Pagina: pagina,
        ContaId: this.$store.getters.getAutenticacao.contaSelecionadaId,
        ContatoId: this.contatoId,
        ItensPorPagina: 5,
        Status: EnumStatusOrcamento.Calculado
      };
      this.$http({
        url: "/orcamento/obter-grid/",
        data: filtro,
        method: "POST"
      })
        .then((response) => {
          this.loading = false;
          this.itens = response.data.itens;
          this.total = response.data.total;
          this.pagina = response.data.pagina;
          this.itensPorPagina = response.data.itensPorPagina;
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    }
  }
};
</script>

<style lang="scss">
.CustomTd {
  /* overflow: hidden;
  max-width: 75ch; */
  max-width: 50ch;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
